export default "__VITE_PUBLIC_ASSET__1f805810__"